import { ApiState } from '../utils/requestAction';
import { Profile } from '../models/Profile';
import requestReducer from './requestReducer';

export interface ProfileState extends ApiState {
  profile?: Profile
}

export default requestReducer<ProfileState>('PROFILE')